import { createElement as rc, useState, useEffect } from 'react';
import lodash from 'lodash';
const { startCase } = lodash;
import { Image, styled } from 'lib_ui-primitives';
import { useTheme } from 'styled-components';

import { getLogo, TRANSPARENT_PIXEL } from '../../images';
import useBrand from '../hooks/useBrand';

export const variants = {
    COLOR: 'color',
    WHITE: 'white',
    SMALL: 'small'
};

const ResponsiveImage = styled(Image).attrs(props => ({
    name: startCase(`${props.brand} Logo`),
    alt: startCase(`${props.variant} ${props.brand} Logo`)
}))`
    width: 100%;
    max-width: 175px;
`;

const _p = {
    useBrand,
    useTheme
};
export const _private = _p;

/**
 * @typedef {Object} Props
 * @property {'color'|'white'|'small'} [variant]
 * @property {Object} [style]
 */
/**
 * @type {import('react').FC<Props>} Logo
 */
const Logo = props => {
    const { variant = variants.WHITE, style } = props;
    const brand = _p.useBrand();
    const theme = _p.useTheme();
    const { darkMode } = theme;
    const [src, setImage] = useState(TRANSPARENT_PIXEL);

    useEffect(() => {
        let allowStateUpdates = true;
        const getImage = async () => {
            const image = await getLogo(brand, variant, darkMode);
            if (allowStateUpdates) {
                setImage(image);
            }
        };
        getImage();
        return () => (allowStateUpdates = false);
    }, [brand, darkMode, variant]);

    // prettier-ignore
    return rc(ResponsiveImage, { src, brand, variant: variant, style });
};

export default Logo;
